module.exports = __webpack_public_path__ + "img/001.4a7f5847.jpg";